import React, {useState} from "react";
import ButtonLoader from "../../utils/components/ButtonLoader";
import {makeApiCall} from "../../Api/makeApiCall";
import SelectDropdown from "./Dropdowns/SelectDropdown";

export const ExtendTimeService = () => {
    const [year, setYear] = useState(2026);
    const years = Array.from({length: 4}, (_, i) => {
        const year = new Date().getFullYear() + i;
        return {value: year, label: year};
    });
    return <>
        <SelectDropdown
            className='time-service-year-extend_dropdown select-dropdown'
            selectValue={year}
            options={years}
            onChange={(option => setYear(option.value))}
        />
        <ButtonLoader
            buttonClassName={'button alert'}
            buttonTitle={'Extend Time Service'}
            buttonHasModal
            modalHeader={'Extend Time Service'}
            userAcknowledgedCheck
            modalText={`Are you sure you want to Extend Time Service for next year?`}
            axiosFunction={makeApiCall}
            url={`${process.env.REACT_APP_EDP_API_BASE_URL}/extendTimeService/${year}`}
            toastTextFailure={`Extend Time Service call failed`}
            toastTextSuccess={`Time Service created for next year.`}
        />
    </>
}